export default __webpack_public_path__ + "static/media/student_mission_4.a3b0ba98.png";